/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconHelp from '@telus-uds/palette-public-mobile/build/rn/icons/Help'
const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { inverse: true }, tokens: { iconColor: '#f5f5f7' } },
    { if: { hover: true }, tokens: { iconScale: 1.25 } },
    { if: { pressed: true }, tokens: { iconColor: '#6a7080' } },
    {
      if: { inverse: true, pressed: true },
      tokens: { iconColor: '#f5f5f7' }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#f39d80' } },
    {
      if: { focus: true, inverse: true },
      tokens: { iconColor: '#f5f5f7', outerBorderColor: '#cdcfd5' }
    },
    {
      if: { focus: true, inverse: true, pressed: true },
      tokens: { iconColor: '#cdcfd5', outerBorderColor: '#cdcfd5' }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { iconColor: '#6a7080', outerBorderColor: '#6a7080' }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 8,
    icon: PaletteIconHelp,
    iconColor: '#394056',
    iconScale: 1,
    iconSize: 16,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 4,
    outerBorderWidth: 2,
    width: 16
  }
}
export default theme
